module.exports = "https://static.wanderu.com/static/media/intercom.7144f74f.svg";